import { Dialog } from '@/components/ui/Dialog'
import { useUiStore } from '@/stores/ui'

import { Composer } from './Composer'

/** 全局发帖弹窗，由 useUiStore.openComposer() 打开。 */
export function ComposerDialog() {
  const open = useUiStore((state) => state.composerOpen)
  const replyTo = useUiStore((state) => state.composerReplyTo)
  const quoteOf = useUiStore((state) => state.composerQuoteOf)
  const close = useUiStore((state) => state.closeComposer)

  return (
    <Dialog open={open} onClose={close}>
      <Composer replyTo={replyTo} quoteOf={quoteOf} autoFocus onDone={close} />
    </Dialog>
  )
}
